import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Assign } from "../types/types";
import { RootState } from "./index.store";

/* Actions */
const actionCreator = actionCreatorFactory("master-assigns");
export const masterAssignsActions = {
  REDUCER_SET_MASTER_ASSIGNS: actionCreator<Assign[]>(
    "REDUCER_SET_MASTER_ASSIGNS"
  )
};

/* Selectors */
export const masterAssignsSelector = (state: RootState) =>
  state.domain.masterAssigns;

/**
 * マスターアサインリデューサー
 */
export const masterAssignsReducer = reducerWithInitialState<Assign[]>([]).case(
  masterAssignsActions.REDUCER_SET_MASTER_ASSIGNS,
  (state, payload) => payload
);
